import { AttributeTypes, SearchConditions, SearchMethods } from "../../documents/models/DocumentFilterAttribute";
import { AttributeFilterDto } from "./attribute-filter.dto";
import { DocumentFilter } from "../../documents/models/DocumentFilter";

export class AttributeField {
    key:string;
    name:string;
    constructor(key:string, name:string) {
        this.key = key;
        this.name = name;
    }
}

export class DocumentFilterDto {
    parent?: string;
    name?: string;
    attributes?:AttributeField[];
    createdFrom?: Date;
    createdTill?: Date;
    userId?: string;    
    path?: string[];
    method?: string;
    condition?: string;
    filters?: AttributeFilterDto[];

    /**
     *
     */
    constructor(parent: string = null) {
        this.name = null;
        this.createdFrom = null;
        this.createdTill = null;
        this.userId = null;
        this.parent = parent;
        this.path = null;        
        this.condition = SearchConditions.bool;
        this.method = SearchMethods.must;
        this.filters = [];
        this.attributes = [];
    }
    public AddFilter(filter: AttributeFilterDto) {
        if (filter) {
            this.filters.push(filter);
        }        
    }
    public AddAttribute(key:string, name:string) {
        this.attributes.push(new AttributeField(key,name));
    }
    public SetAttributes(attributes?:AttributeField[]) {
        this.attributes = attributes;
    }
    public static Create(filter: DocumentFilter, parent: string = null): DocumentFilterDto {
        const ret = new DocumentFilterDto(parent);
        if (filter) {
            ret.name = filter.name;
            ret.userId = filter.userId;
            ret.createdFrom = filter.createdFrom;
            ret.createdTill = filter.createdTill;
            if (filter.attributes) {
                filter.attributes.forEach(attribute => {
                    if (attribute) {
                        switch (attribute.typeCode) {
                            case AttributeTypes.Reference:
                                ret.AddFilter(AttributeFilterDto.CreateReferenceAttribute(attribute.attributeId, attribute.value, attribute.displayValue));
                                break;
                            case AttributeTypes.Date:
                                ret.AddFilter(
                                    AttributeFilterDto.CreateDateAttribute(
                                        attribute.attributeId, 
                                        attribute.operator, 
                                        attribute.value, 
                                        attribute.min, 
                                        attribute.max));
                                break;                                
                            case AttributeTypes.DateTime:
                                ret.AddFilter(
                                    AttributeFilterDto.CreateDateTimeAttribute(
                                        attribute.attributeId, 
                                        attribute.operator, 
                                        attribute.value, 
                                        attribute.min, 
                                        attribute.max));
                                break;                                                                
                            case AttributeTypes.Number:
                                ret.AddFilter(
                                    AttributeFilterDto.CreateNumberAttribute(
                                        attribute.attributeId, 
                                        attribute.operator, 
                                        attribute.value, 
                                        attribute.min, 
                                        attribute.max));
                                break;                                                                                                
                            case AttributeTypes.String:
                                ret.AddFilter(
                                    AttributeFilterDto.CreateStringAttribute(
                                        attribute.attributeId, 
                                        attribute.operator, 
                                        attribute.value, 
                                        attribute.min, 
                                        attribute.max));
                                break;                                                                                                                                
                            case AttributeTypes.Time:
                                ret.AddFilter(
                                    AttributeFilterDto.CreateTimeAttribute(
                                        attribute.attributeId, 
                                        attribute.operator, 
                                        attribute.value, 
                                        attribute.min, 
                                        attribute.max));
                                break;                                                                                                                                                                
                            default:
                                break;
                        }
                    }                    
                });
            }
        }

        return ret;
    }    
}